<template>
  <teleport to="body">
    <transition name="fade">
      <div v-if="isModalOpen" class="fixed top-0 left-0 p-15 w-full h-full bg-backdrop flex justify-center items-center z-50"
           @click.self="close"
      >
        <div class="relative bg-primary max-w-420 w-full rounded-4 p-20">
          <div class="text-app-color">
            <p class="text-22 font-black">Log in</p>

            <form class="w-full mt-20 mb-25" @submit.prevent="login">
              <!-- INPUT CONTROLS -->
              <InputModule
                :model-value="email"
                name="email"
                type="email"
                label="Your email"
                :readonly="true"
                placeholder="email@example.com"
                class="w-full mb-30 font-medium"
                input-classes="px-22 py-14"
                :error-message="errorMessages.email"
                @clearErrorMessage="errorMessages.email = null"
              />

              <InputModule
                v-model="password"
                name="password"
                type="password"
                label="Your password"
                placeholder="password"
                class="w-full mb-30 font-medium"
                input-classes="px-22 py-14"
                :forgot-password="true"
                :error-message="errorMessages.password"
                @clearErrorMessage="errorMessages.password = null"
              />
            </form>
          </div>
          <div class="flex justify-end items-center">
            <ButtonModule
              text="Cancel"
              :has-hover="true"
              class="text-app-color text-15 mr-12"
              @click="close"
            />
            <ButtonModule
              text="Login"
              class="bg-link-color rounded-4 px-35 py-12 text-white text-15 "
              @click="login"
            />
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import { defineComponent, ref, reactive } from 'vue'
import { useStore } from 'vuex'
import { requiredFieldsValidation, emailValidation, passwordValidation } from '@/helpers'

import { preventBodyScroll } from '@/core/helper-functions'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import InputModule from '@/components/shared/form-controls/InputModule'

export default defineComponent({
  components: { ButtonModule, InputModule },

  props: {
    email: String
  },

  emits: ['onLogin'],

  setup (props, { emit }) {
    const { dispatch, commit } = useStore()

    const isModalOpen = ref(false)

    const password = ref(null)
    const errorMessages = reactive({
      email: null,
      password: null
    })

    function login () {
      requiredFieldsValidation(errorMessages, {
        email: props.email,
        password: password.value
      })

      if (!errorMessages.email) errorMessages.email = emailValidation(props.email)

      if (!errorMessages.password) errorMessages.password = passwordValidation(password.value)

      if (Object.values(errorMessages).every(i => !i)) {
        dispatch('signIn', {
          email: props.email.trim(),
          password: password.value
        }).then((res) => {
          emit('onLogin')
        }).catch((data) => {
          commit('setNotification', {
            isVisible: true,
            message: 'Incorrect email or password. Please try again.',
            color: 'error'
          })
        })
      }
    }

    function open () {
      preventBodyScroll(true)
      isModalOpen.value = true
    }

    function close () {
      preventBodyScroll(false)
      isModalOpen.value = false
    }

    return {
      // data
      isModalOpen,
      password,
      errorMessages,
      // function
      open,
      close,
      login
    }
  }
})
</script>
